
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Label } from 'reactstrap';
import TextInput from '../components/TextInput';
import SelectInput from '../components/SelectInput';
import LabelField from '../components/LabelField';
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from 'react-redux';
import ApplicationDetails from '../pages/dashboard/components/ApplicationDetails';
import { ColumnHeaderType } from '../utils/Types';
import { CLICK_ACTIONS, LINE_OF_BUSINESS } from '../utils/Constant';
import { handleCustomerDetailsSearchDataSlice, handleMemberDetailsSlice, handleSearchDataSlice, handleSelectedApplication } from '../redux/slices/grievancesSlice';
import { applicationDetailsSearchApi, customerDetailsSearchApi, policyDetailsSearchApi } from '../api/grievancesApi';
import { mapGrievanceTypeMaster, mapLOBMaster } from '../utils/MastersMapping';
import CustomerDetails from '../pages/dashboard/components/CustomerDetails';
import { getLobData } from '../utils/Util';
import { FormUtils } from '../utils/FormUtils';
import RetailApplicationDetails from '../pages/dashboard/components/RetailApplicationDetails';
import CenterSpinner from '../components/CenterSpinner';
import HealthPolicyDetails from '../pages/dashboard/health/Policies';
import HealthMemberDetails from '../pages/dashboard/health/MemberDetails';

interface SubmitFormData {
  lineOfBusiness: string;
  searchApplication: string;
  searchPolicy: string;
  searchMobile: string;
  searchPMFBYPolicy: string;
  searchRWBCISPolicy: string;
  searchRWBCISApplication: string;

  searchHealthMobile: string;
  searchHealthPolicy: string;
}

const NewGrievanceSearch = (props: any) => {
  const { toggle, openModal } = props
  const [submitData, setSubmitData] = useState<any>();
  const [searchSection, setSearchSection] = useState<boolean>(true);
  const [searchClicked, setSearchClicked] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [callWithMobile, setcallWithMobile] = useState<boolean>(false);
  const [callWithPolicy, setcallWithPolicy] = useState<boolean>(false);
  const [callWithApplication, setcallWithApplication] = useState<boolean>(false);
  const [callWithPMFBYPolicy, setcallWithPMFBYPolicy] = useState<boolean>(false);
  const [callWithRWBCISPolicy, setcallWithRWBCISPolicy] = useState<boolean>(false);
  const [callWithRWBCISApplication, setcallWithRWBCISApplication] = useState<boolean>(false);
  const [callWithHealthMobile, setcallWithHealthMobile] = useState<boolean>(false);
  const [callWithHealthPolicy, setcallWithHealthPolicy] = useState<boolean>(false);
  const [showApplicationTable, setShowApplicationTable] = useState<boolean>(false);
  const [showCustomerTable, setShowCustomerTable] = useState<boolean>(false);
  const [showRetailApplicationTable, setRetailApplicationTable] = useState<boolean>(false);
  const [showHealthDetails, setShowHealthDetails] = useState<boolean>(false);
  const [showHealthMemberDetails, setShowHealthMemberDetails] = useState<boolean>(false);


  const dispatch: any = useDispatch();

  const {
    storeCustomerDetailsSearchData,
    storeLOBData,
    storeApplicationSearchData,
  } = useSelector((state: any) => state.grievances);

  const lobList = getLobData(FormUtils.convertDataList(
    storeLOBData?.data ?? []
  ))

  const closeBtn = (
    <img
      src={require('../assets/img/close_modal.svg').default}
      onClick={() => { toggle(); props.setFlag(false) }}
      style={{ cursor: 'pointer' }}
    ></img>
  );

  const data = useForm<SubmitFormData>({
    defaultValues: {
      lineOfBusiness: '',
      searchApplication: '',
      searchPolicy: '',
      searchMobile: '',
      searchPMFBYPolicy: '',
      searchRWBCISPolicy: '',
      searchRWBCISApplication: '',
      searchHealthMobile: '',
      searchHealthPolicy: '',
    },
    mode: 'all',
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    formState: { errors },
  } = useForm<SubmitFormData>()

  const onChangeInput = (label: any, value: any,) => {
    setValue(label, value, { shouldValidate: true })
  }

  const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
    if (headerItem.action === CLICK_ACTIONS.SELECT_CUSTOMER) {
      if(lob === 'Health') {
        setShowHealthMemberDetails(true);
        setShowHealthDetails(false);
        setShowCustomerTable(false);
        const { members, ...rest } = each;
        const memberDetails = members.map((member: any) => ({ ...rest, customerName: member.memberName, memberId: member.memberId }));
        dispatch(handleMemberDetailsSlice(memberDetails));
      } else {
        toggle();
        props.setOpenNewModal(true);
      }
    }
    if (headerItem.action === CLICK_ACTIONS.SELECT_HEALTH_MEMBER) {      
      dispatch(handleCustomerDetailsSearchDataSlice(each));
      dispatch(handleSelectedApplication(each));
      toggle();
      props.setOpenNewModal(true);
    }
    if (headerItem.action === CLICK_ACTIONS.SELECT_APPLICATION) {
      dispatch(handleSelectedApplication(each));
      setShowCustomerTable(true);
      setShowApplicationTable(false);
    }
    if (headerItem.action === CLICK_ACTIONS.SELECT_RETAIL_APPLICATION) {
      dispatch(handleSelectedApplication(each));
      setShowCustomerTable(true);
      setRetailApplicationTable(false);
    }
    if (headerItem.action === CLICK_ACTIONS.SELECT_HEALTH_APPLICATION) {
      dispatch(handleSelectedApplication(each));
      setShowCustomerTable(true);
      setShowHealthDetails(false);
    }
  }

  const onSubmit = (data: SubmitFormData) => {
    setSubmitData(data);
    setSearchClicked(true);

    if (data?.searchApplication?.length > 0) {
      setSearchValue(data?.searchApplication);
      setcallWithApplication(true);
    } else if (data?.searchMobile?.length > 0) {
      setSearchValue(data?.searchMobile);
      setcallWithMobile(true);
    } else if (data?.searchPolicy?.length > 0) {
      setSearchValue(data?.searchPolicy);
      setcallWithPolicy(true);
    } else if (data?.searchPMFBYPolicy?.length > 0) {
      setSearchValue(data?.searchPMFBYPolicy);
      setcallWithPMFBYPolicy(true);
    } else if (data?.searchRWBCISPolicy?.length > 0) {
      setSearchValue(data?.searchRWBCISPolicy);
      setcallWithRWBCISPolicy(true);
    } else if (data?.searchRWBCISApplication?.length > 0) {
      setSearchValue(data?.searchRWBCISApplication);
      setcallWithRWBCISApplication(true);
    } else if (data?.searchHealthMobile?.length > 0) {
      setSearchValue(data?.searchHealthMobile);
      setcallWithHealthMobile(true);
    } else if (data?.searchHealthPolicy?.length > 0) {
      setSearchValue(data?.searchHealthPolicy);
      setcallWithHealthPolicy(true);
    }
  };

  useEffect(() => {
    if (searchClicked) {
      const timer = setTimeout(() => {
        setSearchClicked(false);
      }, 2000);
    return () => clearTimeout(timer);
    }
  }, [searchClicked]);


  const lob = watch("lineOfBusiness");
  useEffect(() => {
    if (lob === "Crop(PMFBY)") {
      setValue("searchMobile", "");
      setValue("searchPolicy", "");
      setValue("searchRWBCISPolicy", "");
      setValue("searchRWBCISApplication", "");
      setValue("searchHealthPolicy", "");
      setValue("searchHealthMobile", "");
    } else if (lob === "Crop - Retail") {
      setValue("searchPMFBYPolicy", "");
      setValue("searchApplication", "");
      setValue("searchRWBCISPolicy", "");
      setValue("searchRWBCISApplication", "");
      setValue("searchHealthPolicy", "");
      setValue("searchHealthMobile", "");
    } else if (lob === "RWBCIS") {
      setValue("searchPMFBYPolicy", "");
      setValue("searchApplication", "");
      setValue("searchMobile", "");
      setValue("searchPolicy", "");
      setValue("searchHealthPolicy", "");
      setValue("searchHealthMobile", "");
    } else if (lob === "Health") {
      setValue("searchMobile", "");
      setValue("searchPolicy", "");
      setValue("searchPMFBYPolicy", "");
      setValue("searchApplication", "");
      setValue("searchRWBCISPolicy", "");
      setValue("searchRWBCISApplication", "");
    }
  }, [lob]);

  useEffect(() => {
    if (searchValue?.length > 0 && Object.keys(submitData).length > 0) {
      if (
        mapLOBMaster(submitData?.lineOfBusiness) ===
        LINE_OF_BUSINESS.CROP_RETAIL
      ) {
        dispatch(
          customerDetailsSearchApi(
            submitData,
            searchValue,
            callWithMobile,
            callWithPolicy,
          ),
        );
      } else if (
        mapLOBMaster(submitData?.lineOfBusiness) ===
        LINE_OF_BUSINESS.HEALTH
      ) {
        dispatch(customerDetailsSearchApi(
          submitData,
          searchValue,
          callWithHealthMobile,
          callWithHealthPolicy
        ));
      } else if (
        mapLOBMaster(submitData.lineOfBusiness === LINE_OF_BUSINESS.PMFBY)
      ) {
        dispatch(
          applicationDetailsSearchApi(
            submitData,
            searchValue,
            callWithApplication,
            callWithPMFBYPolicy,
          ),
        );
      } else if (
        mapLOBMaster(submitData.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS
      ) {
        dispatch(
          applicationDetailsSearchApi(
            submitData,
            searchValue,
            callWithRWBCISApplication,
            callWithRWBCISPolicy,
          ),
        );
      }
      dispatch(handleSearchDataSlice(submitData));
    }
  }, [submitData, searchValue]);

  useEffect(() => {
    if (storeCustomerDetailsSearchData?.statusId === 200 && submitData) {
      setSearchSection(false);
      if (submitData?.searchMobile?.length > 0) {
        setShowCustomerTable(false);
        setRetailApplicationTable(true);
      } else if (submitData?.searchPolicy?.length > 0) {
        setShowCustomerTable(true);
        setRetailApplicationTable(false);
      } else if (submitData?.searchHealthPolicy?.length > 0) {
        setShowCustomerTable(true);
        setShowHealthDetails(false);
      } else if (submitData?.searchHealthMobile?.length > 0) {
        setShowCustomerTable(false);
        setShowHealthDetails(true);
      }
      setShowApplicationTable(false);
      setcallWithPolicy(false);
      setcallWithMobile(false);
      setIsLoading(false);
    } else if (storeCustomerDetailsSearchData?.statusId === 500) {
      if (
        (((callWithMobile && callWithPolicy) || (!callWithMobile && !callWithPolicy)) && mapLOBMaster(submitData.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL) ||
        (((callWithHealthMobile && callWithHealthPolicy) || (!callWithHealthMobile && !callWithHealthPolicy)) && mapLOBMaster(submitData.lineOfBusiness) == LINE_OF_BUSINESS.HEALTH)
      ) {
        toggle();
        props.setOpenNewModal(true);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [storeCustomerDetailsSearchData]);

  useEffect(() => {
    if (storeApplicationSearchData?.statusId === 200 && submitData) {
      setSearchSection(false);
      setShowCustomerTable(false);
      setRetailApplicationTable(false);
      setShowApplicationTable(true);
      setcallWithApplication(false);
      setcallWithPMFBYPolicy(false);
      setcallWithRWBCISPolicy(false);
      setcallWithRWBCISApplication(false);
      setIsLoading(false);
    } else if (storeApplicationSearchData?.statusId === 500) {
      if (callWithApplication && callWithPMFBYPolicy) {
        toggle();
        props.setOpenNewModal(true);
      }
      if (callWithRWBCISApplication && callWithRWBCISPolicy) {
        toggle();
        props.setOpenNewModal(true);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [storeApplicationSearchData]);

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (submitData && Object.keys(submitData).length > 0) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 50000);
    }
  }, [submitData]);

  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={toggle}
        centered={true}
        size="lg"
        backdrop={"static"}
        className="modal-size-custom2"
      >
        <ModalHeader toggle={toggle} close={closeBtn}>
          {searchSection ? (
            <span>Create New Grievance</span>
          ) : (
            <>
              {showCustomerTable ? (
                <span>Select Customer</span>
              ) : showHealthMemberDetails ? (
                <span>Select Member</span>
              ) : (
                <span>Select Application</span>
              )}
            </>
          )}
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <ModalBody>
            {searchSection ? (
              <>
                <Row>
                  <Col xs={6} md={6} className="mb-3">
                    <SelectInput
                      label="Line of Business"
                      data={lobList}
                      valueName={"lineOfBusiness"}
                      register={register("lineOfBusiness")}
                      changeFun={onChangeInput}
                      required={true}
                      formValue={getValues("lineOfBusiness")}
                    />
                  </Col>
                </Row>
                <Row>
                  {(lob === "Crop - Retail" || !lob) && (
                    <>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Mobile Number"
                          valueName={"searchMobile"}
                          changeFun={onChangeInput}
                          register={register("searchMobile", {
                            pattern: /^[6-9]{1}[0-9]{9}$/i,
                          })}
                          formValue={getValues("searchMobile")}
                          errors={errors}
                          maxLength={10}
                          disabled={getValues("searchPolicy") ? true : false}
                          required={getValues("searchMobile") ? false : true}
                        />
                      </Col>
                      <Col xs={2} md={2} className="mt-4">
                        <LabelField name="OR" />
                      </Col>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Policy Number"
                          valueName={"searchPolicy"}
                          changeFun={onChangeInput}
                          register={register("searchPolicy")}
                          formValue={getValues("searchPolicy")}
                          errors={errors}
                          disabled={getValues("searchMobile") ? true : false}
                          required={getValues("searchMobile") ? false : true}
                        />
                      </Col>
                    </>
                  )}
                  {lob === "Crop(PMFBY)" && (
                    <>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Application Number"
                          valueName={"searchApplication"}
                          changeFun={onChangeInput}
                          register={register("searchApplication", {
                            pattern: /^[0-9]{21}[0-9]*$/i,
                          })}
                          formValue={getValues("searchApplication")}
                          errors={errors}
                          disabled={
                            getValues("searchPMFBYPolicy") ? true : false
                          }
                          required={
                            getValues("searchPMFBYPolicy") ? false : true
                          }
                        />
                      </Col>
                      <Col xs={2} md={2} className="mt-4">
                        <LabelField name="OR" />
                      </Col>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Policy Number"
                          valueName={"searchPMFBYPolicy"}
                          changeFun={onChangeInput}
                          register={register("searchPMFBYPolicy", {
                            pattern: /^[0-9]{19}$/i,
                          })}
                          formValue={getValues("searchPMFBYPolicy")}
                          errors={errors}
                          maxLength={19}
                          disabled={
                            getValues("searchApplication") ? true : false
                          }
                          required={
                            getValues("searchApplication") ? false : true
                          }
                        />
                      </Col>
                    </>
                  )}
                  {lob === "RWBCIS" && (
                    <>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Application Number"
                          valueName={"searchRWBCISApplication"}
                          changeFun={onChangeInput}
                          register={register("searchRWBCISApplication")}
                          formValue={getValues("searchRWBCISApplication")}
                          errors={errors}
                          disabled={
                            getValues("searchRWBCISPolicy") ? true : false
                          }
                          required={
                            getValues("searchRWBCISPolicy") ? false : true
                          }
                        />
                      </Col>
                      <Col xs={2} md={2} className="mt-4">
                        <LabelField name="OR" />
                      </Col>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Policy Number"
                          valueName={"searchRWBCISPolicy"}
                          changeFun={onChangeInput}
                          register={register("searchRWBCISPolicy")}
                          formValue={getValues("searchRWBCISPolicy")}
                          errors={errors}
                          disabled={
                            getValues("searchRWBCISApplication") ? true : false
                          }
                          required={
                            getValues("searchRWBCISApplication") ? false : true
                          }
                        />
                      </Col>
                    </>
                  )}
                  {lob === "Health" && (
                    <>
                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Mobile Number"
                          valueName={"searchHealthMobile"}
                          changeFun={onChangeInput}
                          register={register("searchHealthMobile", {
                            pattern: /^[6-9]{1}[0-9]{9}$/i,
                          })}
                          formValue={getValues("searchHealthMobile")}
                          errors={errors}
                          maxLength={10}
                          disabled={
                            getValues("searchHealthPolicy") ? true : false
                          }
                          required={
                            getValues("searchHealthPolicy") ? false : true
                          }
                        />
                      </Col>

                      <Col xs={2} md={2} className="mt-4">
                        <LabelField name="OR" />
                      </Col>

                      <Col xs={5} md={5} className="mb-3">
                        <TextInput
                          label="Policy Number"
                          valueName={"searchHealthPolicy"}
                          changeFun={onChangeInput}
                          register={register("searchHealthPolicy")}
                          formValue={getValues("searchHealthPolicy")}
                          errors={errors}
                          disabled={
                            getValues("searchHealthMobile") ? true : false
                          }
                          required={
                            getValues("searchHealthMobile") ? false : true
                          }
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </>
            ) : (
              <>
                {showApplicationTable && (
                  <ApplicationDetails
                    searchSection={searchSection}
                    setSearchSection={setSearchSection}
                    setShowApplicationTable={setShowApplicationTable}
                    getValues={getValues}
                    onTableAction={onTableAction}
                  />
                )}
                {showCustomerTable && (
                  <CustomerDetails
                    setShowApplicationTable={setShowApplicationTable}
                    setShowCustomerTable={setShowCustomerTable}
                    setRetailApplicationTable={setRetailApplicationTable}
                    setShowHealthDetails={setShowHealthDetails}
                    setSearchSection={setSearchSection}
                    getValues={getValues}
                    onTableAction={onTableAction}
                  />
                )}
                {showRetailApplicationTable && (
                  <RetailApplicationDetails
                    searchSection={searchSection}
                    setSearchSection={setSearchSection}
                    setRetailApplicationTable={setRetailApplicationTable}
                    getValues={getValues}
                    onTableAction={onTableAction}
                  />
                )}
                {showHealthDetails && (
                  <HealthPolicyDetails
                    searchSection={searchSection}
                    setSearchSection={setSearchSection}
                    setShowHealthDetails={setShowHealthDetails}
                    getValues={getValues}
                    onTableAction={onTableAction}
                  />
                )}
                {showHealthMemberDetails && (
                  <HealthMemberDetails
                    setShowCustomerTable={setShowCustomerTable}
                    setShowHealthMemberDetails={setShowHealthMemberDetails}
                    getValues={getValues}
                    onTableAction={onTableAction}
                  />
                )}
              </>
            )}
          </ModalBody>
          {searchSection && (
            <ModalFooter>
              <Button
                className="button"
                type="submit"
                style={{ width: "91px" }}
                disabled={searchClicked}
              >
                Search
              </Button>{" "}
              <Button
                onClick={() => {
                  toggle();
                  props.setFlag(false);
                }}
                className="resetButton"
                style={{ width: "91px" }}
              >
                Cancel
              </Button>
            </ModalFooter>
          )}
        </form>
      </Modal>
      <CenterSpinner showLoader={isLoading} />
    </>
  );
};

export default NewGrievanceSearch;